import { useCalendars, useDatePickerOffsetPropGetters } from "@rehookify/datepicker";
import { IconButton } from "@/components/atoms";
import { DatePicker } from "@/components/atoms/DateRangePicker/DatePicker";
import { useDateRangePicker } from "@/components/atoms/DateRangePicker/context";

export const MobileDatePickerContent = () => {
  const { dpState } = useDateRangePicker();
  const { calendars } = useCalendars(dpState);
  const { subtractOffset, addOffset } = useDatePickerOffsetPropGetters(dpState);

  return (
    <div className="flex max-h-[375px] flex-col items-center overflow-auto">
      <DatePicker
        prevButton={
          <IconButton iconName="ArrowLeft2" iconSize="sm" variant="tertiary-light" className="h-6 w-8 p-0" {...subtractOffset({ months: 1 })} />
        }
        nextButton={
          <IconButton iconName="ArrowRight2" iconSize="sm" variant="tertiary-light" className="h-6 w-8 p-0" {...addOffset({ months: 1 })} />
        }
        calendar={calendars[0]}
      />
      <DatePicker
        prevButton={
          <IconButton iconName="ArrowLeft2" iconSize="sm" variant="tertiary-light" className="h-6 w-8 p-0" {...subtractOffset({ months: 1 })} />
        }
        nextButton={
          <IconButton iconName="ArrowRight2" iconSize="sm" variant="tertiary-light" className="h-6 w-8 p-0" {...addOffset({ months: 1 })} />
        }
        calendar={calendars[1]}
      />
    </div>
  );
};
